import * as React from 'react';
import CookieConsent from 'react-cookie-consent';

class CookieNotice extends React.Component {
  public render() {
    return (
        <CookieConsent
            location="bottom"
            buttonText="Verstanden"
            cookieName="myAwesomeCookieName2"
            style={{ background: 'rgb(230, 230, 230)', color: 'rgb(24, 109, 146)' }}
            buttonStyle={{ background: '#7ED321', color: '#2A4708', fontSize: '14px' }}
            expires={150}
        >
            Diese Website benutzt Cookies und blendet Werbung ein. 
            Wenn Sie die Website weiter nutzen, 
            gehen wir von Ihrem Einverständnis der Nutzung aus. 
            Alles weitere unter 
            <a 
                href="https://www.stellenanbieter.de/datenschutz" 
                style={{color: 'rgb(24, 109, 146)', paddingLeft: '5px'}} 
                target="_blank"
            >
                Datenschutz
            </a>
        </CookieConsent>
    );
  }
}

export default CookieNotice;



// WEBPACK FOOTER //
// ./src/CookieNotice.tsx